<template lang="pug">
  .pos-list(v-if='posData')
    .pos-item(v-for='pos in orderedPosList' :key='pos.Id' :class="{'is-active': (selectedRestaurant && (pos.Id === selectedRestaurant.pos.Id))}" @click.prevent="$emit('change',pos)")
      div.pos-item__inner
        p
          span.pos-name.color-brand Phở cuốn Hương Mai
          span.pos-dist(v-if="pos.Distance") {{ pos.Distance }}km
        p
          span.post-address {{ pos.Pos_Address }}
      svg(class="pos-item__arrow" width='19' height='17' viewbox='0 0 19 17' fill='none' xmlns='http://www.w3.org/2000/svg')
        path(d='M10.7045 1.28395C10.3111 0.896331 9.678 0.901021 9.2904 1.29443C8.9027 1.68783 8.9074 2.32098 9.3008 2.7086L14.6712 8H1C0.44771 8 0 8.4477 0 9C0 9.5523 0.44772 10 1 10H14.6646L9.3008 15.2849C8.9074 15.6725 8.9027 16.3057 9.2904 16.6991C9.678 17.0925 10.3111 17.0972 10.7045 16.7095L17.6287 9.8871C18.1256 9.3975 18.1256 8.5959 17.6287 8.1063L10.7045 1.28395Z' fill='#ADA8A8')

</template>
<script>
  import _ from 'lodash';
  import {mapState} from 'vuex'
  export default {
    name: 'HeaderPosList',
    props: {
      posData: Array,
      location: Object,
    },
    created () {
    },
    methods: {
      setPos(pos) {
      },
    },
    computed: {
      ...mapState({
        selectedRestaurant: state => state.restaurants.selectedRestaurant,
      }),
      orderedPosList: function () {
        if (this.location) {
          let arr = this.posData, current = this.selectedRestaurant, calc;
          if (arr) {
            let loc = this.location;
            const rad = function (x) {
              return x * Math.PI / 180;
            };

            arr.forEach(function (e, i) {
              const p1 = {
                lng: e.Pos_Longitude,
                lat: e.Pos_Latitude,
              };
              const p2 = loc;
              const R = 6378137; // Earth’s mean radius in meter
              const dLat = rad(p2.lat - p1.lat);
              const dLong = rad(p2.lng - p1.lng);
              const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
                Math.sin(dLong / 2) * Math.sin(dLong / 2);
              const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
              const d = R * c / 1000;
              arr[i].Distance = parseFloat(d.toFixed(2));
              if (current && arr[i].Id === current.pos.Id) {
                calc = arr[i]
              }
            })
          }
          //if (calc) this.$emit('initPos', calc)
          return _.orderBy(arr, 'Distance')
        } else {
          return  this.posData
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/HeaderPosList.vue